import axios from "axios";
import { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";

function AddOrder({ toggleSidebar }) {
    const toast = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [generateNumber, setGenerateNumber] = useState("");
    const [customerData, setCustomerData] = useState([]);
    const [staffData, setStaffData] = useState([]);
    const [displayList, setDisplayList] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showStaffModal, setShowStaffModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [generateCustomerNumber, setGenerateCustomerNumber] = useState("");
    const [paymentModal, setPaymentModal] = useState(false);
    const [paymentType, setPaymentType] = useState("");
    const [paymentAmount, setPaymentAmount] = useState("");
    const [payments, setPayments] = useState([]);
    const [typeGetting, setTypeGetting] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [actionType, setActionType] = useState("");
    const [editingItemId, setEditingItemId] = useState(null);
    const [userdata, setUserdata] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [selectedManager, setSelectedManager] = useState("");
    const [selectedStaff, setSelectedStaff] = useState("");
    const [staffList, setStaffList] = useState([]);
    const [shopList, setShopList] = useState([]); // past "By Shop" shop names, for the autofill dropdown
    const [isManagerLocked, setIsManagerLocked] = useState(false);
    const [isStaffLocked, setIsStaffLocked] = useState(false);
    const [isTranslating, setIsTranslating] = useState(false);
    const [productFormErrors, setProductFormErrors] = useState({});
    const [productAddData, setProductAddData] = useState({
        item_code: "",
        item_name: "",
        item_name_english: "",
        item_name_tamil: "",
        category: "",
        type: "",
        pure_percent: "",
        status: "Active",
        image: null,
    });

    const [addData, setAddData] = useState({
        order_by: "",
        order_no: "",
        order_date: getCurrentDate(),
        delivery_date: "",
        delivery_status: "Inprogress",
        customer_id: "",
        customer_name: "",
        mobile: "",
        order_items: [],
        advance_amount: "",
        advance_paytype: "",
        balance: "",
        paid: "",
        total: "",
        created_by: "",
        created_date: "",
        payment_history: [],
        customer_type: "",
        name: "",
        name_tamil: "",
        address: "",
        status: "Active",
        item_code: "",
        item_name: "",
        category: "",
        type: "",
        percentage: "",
        image: null,
        manager: "",
        manager_name: "",
        staff: "",
        user_id: "",
        role: "Employee",
        password: "",
        manager_id: "",
        login_status: "Active",
    });

    const [newItem, setNewItem] = useState({
        order_no: "",
        product: "",
        category: "",
        quantity: "1",
        weight: "",
        rate: "",
        making_charge: "",
        making_wastage: "",
        amount: "",
        adjustment: "0"
    });

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const translateToTamil = async (englishText) => {
        if (!englishText || englishText.trim().length < 2) return "";

        setIsTranslating(true);

        const apis = [
            async () => {
                const encoded = encodeURIComponent(englishText.trim());
                const res = await fetch(
                    `https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`,
                );
                const data = await res.json();
                const translated = data?.responseData?.translatedText;
                if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
                    return translated;
                }
                return null;
            },
            async () => {
                const encoded = encodeURIComponent(englishText.trim());
                const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
                if (res.ok) {
                    const data = await res.json();
                    if (data.translation && data.translation !== englishText) {
                        return data.translation;
                    }
                }
                return null;
            },
            async () => {
                const res = await fetch("https://libretranslate.com/translate", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        q: englishText.trim(),
                        source: "en",
                        target: "ta",
                        format: "text",
                    }),
                });
                if (res.ok) {
                    const data = await res.json();
                    if (data.translatedText) {
                        return data.translatedText;
                    }
                }
                return null;
            },
        ];

        for (const api of apis) {
            try {
                const result = await api();
                if (result) {
                    setIsTranslating(false);
                    return result;
                }
            } catch (error) {
                console.warn("Translation API failed:", error);
                continue;
            }
        }

        setIsTranslating(false);
        return "";
    };

    // Fetch Functions
    const fetchStaffData = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/user.php`);
            setStaffData(res.data?.data || []);
        } catch (err) {
            console.error("Failed to load staff:", err);
            toast.error("Failed to load staff", 3000, "topRight");
        }
    };

    const fetchCustomerData = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/customer.php`);
            setCustomerData(res.data?.data || []);
        } catch (err) {
            console.error("Failed to load customers:", err);
            toast.error("Failed to load customers", 3000, "topRight");
        }
    };

    const fetchDataGenerate = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/orders.php/generate-order-number`);
            setGenerateNumber(res.data.order_no || "");
        } catch (err) {
            console.error("Failed to generate order number:", err);
            setGenerateNumber("");
        }
    };

    const fetchProductData = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/product.php`);
            setProductData(res.data?.data || []);
        } catch (err) {
            console.error("Failed to load products:", err);
            toast.error("Failed to load products", 3000, "topRight");
        }
    };

    const fetchProductType = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/product_type.php`);
            setTypeGetting(res.data?.data || []);
        } catch (err) {
            console.error("Failed to load types:", err);
            toast.error("Failed to load types", 3000, "topRight");
        }
    };

    const fetchProductItemCode = async () => {
        try {
            const response = await axios.get(`${ApiUrl}/Api/product.php/generate-item-code`);
            setProductAddData((prev) => ({
                ...prev,
                item_code: response.data?.item_code || "",
            }));
        } catch (error) {
            console.error("Error fetching product item code:", error.message);
            toast.error("Failed to generate product code", 3000, "topRight");
        }
    };

    const openProductModal = () => {
        fetchProductItemCode();
        setProductAddData({
            item_code: "",
            item_name: "",
            item_name_english: "",
            item_name_tamil: "",
            category: "",
            type: "",
            pure_percent: "",
            status: "Active",
            image: null,
        });
        setProductFormErrors({});
        setShowProductModal(true);
    };

    const closeProductModal = () => {
        setShowProductModal(false);
        setProductAddData({
            item_code: "",
            item_name: "",
            item_name_english: "",
            item_name_tamil: "",
            category: "",
            type: "",
            pure_percent: "",
            status: "Active",
            image: null,
        });
        setProductFormErrors({});
    };

    const fetchLoggedInUser = () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
            if (userInfo && userInfo.user_id) {
                setLoggedInUser(userInfo);
            }
        } catch (error) {
            console.error("Error reading logged-in user:", error);
        }
    };

    const fetchUserData = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/user.php`);
            const users = Array.isArray(res.data.data) ? res.data.data : [];
            setUserdata(users);
        } catch (err) {
            console.error("Failed to fetch users", err);
            toast.error("Failed to load staff data", 3000, 'topRight');
        }
    };

    // Pull the distinct shop names (with their mobile numbers) used on past
    // "By Shop" orders, so the next order can pick one from a dropdown instead
    // of retyping it — while still allowing a fresh name to be typed in.
    const fetchShopList = async () => {
        try {
            const res = await axios.get(`${ApiUrl}/Api/orders.php`);
            const allOrders = Array.isArray(res.data.data) ? res.data.data : [];
            const seen = new Map();
            allOrders.forEach((o) => {
                const name = (o.shop_name || "").trim();
                if (!o.order_by || o.order_by !== "By Shop" || !name) return;
                // Keep the most recent mobile number for a given shop name
                // (orders come back newest-first, so the first hit wins).
                if (!seen.has(name.toLowerCase())) {
                    seen.set(name.toLowerCase(), { name, mobile: (o.shop_mobile || "").trim() });
                }
            });
            setShopList(Array.from(seen.values()));
        } catch (err) {
            console.error("Failed to fetch shop list", err);
        }
    };

    // Display List Logic
    useEffect(() => {
        if (addData.order_by === "By Customer") {
            const sorted = [...customerData].sort((a, b) => a.name.localeCompare(b.name));
            setDisplayList(sorted);
        } else {
            setDisplayList([]);
        }
    }, [addData.order_by, customerData]);

    useEffect(() => {
        setAddData(prev => ({ ...prev, customer_id: "", customer_name: "", mobile: "" }));
    }, [addData.order_by]);

    const handlePersonChange = (e) => {
        const val = e.target.value;
        if (!val) {
            setAddData(prev => ({ ...prev, customer_id: "", customer_name: "", mobile: "" }));
            return;
        }
        const cust = customerData.find(c => `${c.customer_id}-${c.id}` === val);
        if (cust) {
            setAddData(prev => ({
                ...prev,
                customer_id: cust.customer_id,
                customer_name: cust.name,
                mobile: cust.mobile || ""
            }));
        }
    };

    // "By Shop" orders are placed by another shop, not one of our own staff.
    // The name is typed/picked from a datalist built from past shop orders —
    // if it matches a shop we've seen before, autofill its mobile number too;
    // otherwise it's a brand-new shop and the mobile is left for manual entry.
    const handleShopNameChange = (e) => {
        const value = e.target.value;
        const trimmed = value.trim();
        const match = shopList.find(s => s.name.toLowerCase() === trimmed.toLowerCase());
        setAddData(prev => ({
            ...prev,
            customer_name: value,
            customer_id: trimmed,
            mobile: match ? match.mobile : (trimmed === "" ? "" : prev.mobile),
        }));
    };

    const handleShopMobileChange = (e) => {
        const value = e.target.value;
        setAddData(prev => ({ ...prev, mobile: value }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAddData(prev => ({ ...prev, [name]: value }));
    };

    const handleItemInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "product") {
            const selectedProduct = filteredProducts.find(p => p.item_name === value);
            setNewItem(prev => ({
                ...prev,
                [name]: value,
                item_name_english: selectedProduct?.item_name_english || selectedProduct?.item_name || value,
                item_name_tamil: selectedProduct?.item_name_tamil || ""
            }));
        } else {
            setNewItem(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) setAddData(prev => ({ ...prev, image: file }));
    };

    const calculateAmount = (item) => {
        if (item.quantity && item.weight && item.rate) {
            const baseAmount =
                parseFloat(item.quantity) * parseFloat(item.weight) * parseFloat(item.rate);
            const isCoin = item.category === "Gold Coin" || item.category === "Silver Coin";
            const makingCharge = isCoin ? 0 : parseFloat(item.making_charge) || 0;
            const makingWastage = isCoin ? 0 : parseFloat(item.making_wastage) || 0;
            const adjustment = parseFloat(item.adjustment) || 0;
            return (baseAmount + makingCharge + makingWastage + adjustment).toFixed(2);
        }
        return "";
    };

    const handleAdjustmentChange = (delta) => {
        setNewItem(prev => {
            const adj = (parseFloat(prev.adjustment) || 0) + delta;
            return { ...prev, adjustment: adj.toFixed(2) };
        });
    };

    const handleAddItem = () => {
        if (!newItem.category) {
            toast.error("Please select a category", 3000, "topRight");
            return;
        }
        if (!newItem.product) {
            toast.error("Please select a product", 3000, "topRight");
            return;
        }
        if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
            toast.error("Please enter a valid quantity", 3000, "topRight");
            return;
        }
        if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
            toast.error("Please enter a valid weight", 3000, "topRight");
            return;
        }
        if (!newItem.rate || parseFloat(newItem.rate) <= 0) {
            toast.error("Please enter a valid rate", 3000, "topRight");
            return;
        }

        const amount = calculateAmount(newItem);
        const item = { ...newItem, id: Date.now(), amount, order_no: generateNumber };
        const updated = [...addData.order_items, item];
        const total = updated.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);

        setAddData(prev => ({
            ...prev,
            order_items: updated,
            total,
            balance: (parseFloat(total) - (parseFloat(prev.advance_amount || 0) + parseFloat(prev.paid || 0))).toFixed(2)
        }));

        setNewItem({
            order_no: generateNumber,
            product: "",
            category: "",
            quantity: "1",
            weight: "",
            rate: "",
            making_charge: "",
            making_wastage: "",
            amount: "",
            adjustment: "0"
        });
    };

    const handleEditItem = (item) => {
        setEditingItemId(item.id);
        setNewItem({
            order_no: item.order_no || generateNumber,
            product: item.product,
            category: item.category,
            quantity: item.quantity,
            weight: item.weight,
            rate: item.rate,
            making_charge: item.making_charge,
            making_wastage: item.making_wastage,
            amount: item.amount,
            adjustment: item.adjustment || "0"
        });
    };

    const handleUpdateItem = () => {
        if (!editingItemId) return;

        const updated = addData.order_items.map(i =>
            i.id === editingItemId
                ? { ...i, ...newItem, amount: calculateAmount(newItem) }
                : i
        );

        const total = updated.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);

        setAddData(prev => ({
            ...prev,
            order_items: updated,
            total,
            balance: (parseFloat(total) - (parseFloat(prev.advance_amount || 0) + parseFloat(prev.paid || 0))).toFixed(2)
        }));

        setEditingItemId(null);
        setNewItem({
            order_no: generateNumber,
            product: "",
            category: "",
            quantity: "1",
            weight: "",
            rate: "",
            making_charge: "",
            making_wastage: "",
            amount: "",
            adjustment: "0"
        });
    };

    const handleRemoveItem = (id) => {
        const filtered = addData.order_items.filter(i => i.id !== id);
        const total = filtered.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);

        setAddData(prev => ({
            ...prev,
            order_items: filtered,
            total,
            balance: (parseFloat(total) - (parseFloat(prev.advance_amount || 0) + parseFloat(prev.paid || 0))).toFixed(2)
        }));
    };

 const handleAdvanceChange = (e) => {
    const advance = e.target.value || "0";
    const advancePaytype = addData.advance_paytype || "";

    if (advancePaytype && parseFloat(advance) > 0) {
        const advancePayment = {
            order_no: addData.order_no,
            date: getCurrentDate(),
            payment_type: advancePaytype,
            amount: parseFloat(advance),
        };

        const allPayments = [advancePayment, ...payments];
        const totalPaid = allPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
        );

        setAddData((prev) => ({
            ...prev,
            advance_amount: advance,
            paid: totalPaid.toFixed(2),
            balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
            payment_history: allPayments,
        }));
    } else {
        // No real advance yet — payment_history should only reflect actual added payments
        const totalPaid = payments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
        );
        setAddData((prev) => ({
            ...prev,
            advance_amount: advance,
            paid: totalPaid.toFixed(2),
            balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
            payment_history: payments,
        }));
    }
};

    const handleAddPayment = () => {
        if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
            toast.error("Please select payment type and enter a valid amount", 3000, "topRight");
            return;
        }

        const newPayment = {
            order_no: addData.order_no,
            date: getCurrentDate(),
            payment_type: paymentType,
            amount: parseFloat(paymentAmount),
        };

let allPayments = [...payments, newPayment];
const hasValidAdvance = addData.advance_paytype && parseFloat(addData.advance_amount) > 0;
if (hasValidAdvance) {
    const advancePayment = {
        order_no: addData.order_no,
        date: getCurrentDate(),
        payment_type: addData.advance_paytype,
        amount: parseFloat(addData.advance_amount),
    };
    allPayments = [advancePayment, ...allPayments];
}

        const totalPaid = allPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
        );

        setAddData((prev) => ({
            ...prev,
            paid: totalPaid.toFixed(2),
            balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
            payment_history: allPayments,
        }));

        setPayments([...payments, newPayment]);
        setPaymentType("");
        setPaymentAmount("");
    };

    const handleEditPayment = (index) => {
        const paymentToEdit = payments[index];
        setPaymentType(paymentToEdit.payment_type);
        setPaymentAmount(paymentToEdit.amount);

        const updatedPayments = payments.filter((_, i) => i !== index);
        setPayments(updatedPayments);

        const totalPaid = updatedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
        );

        setAddData((prev) => ({
            ...prev,
            paid: totalPaid.toFixed(2),
            balance: (
                parseFloat(prev.total || 0) -
                (parseFloat(prev.advance_amount || 0) + totalPaid)
            ).toFixed(2),
            payment_history: updatedPayments,
        }));
    };

    const handleDeletePayment = (index) => {
        const updatedPayments = payments.filter((_, i) => i !== index);
        setPayments(updatedPayments);

        const totalPaid = updatedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
        );

        setAddData((prev) => ({
            ...prev,
            paid: totalPaid.toFixed(2),
            balance: (
                parseFloat(prev.total || 0) -
                (parseFloat(prev.advance_amount || 0) + totalPaid)
            ).toFixed(2),
            payment_history: updatedPayments,
        }));
    };

    const validateForm = () => {
        if (!addData.order_by) {
            toast.error("Please select order by", 3000, "topRight");
            return false;
        }
        if (!addData.customer_id) {
            toast.error(
                addData.order_by === "By Shop"
                    ? "Please enter the shop name"
                    : "Please select a customer",
                3000,
                "topRight"
            );
            return false;
        }
        if (addData.order_items.length === 0) {
            toast.error("Please add at least one item", 3000, "topRight");
            return false;
        }
        if (!addData.order_date) {
            toast.error("Please select an order date", 3000, "topRight");
            return false;
        }
        if (!selectedManager) {
            toast.error("Please select a Manager", 3000, "topRight");
            return false;
        }
        const currentRole = JSON.parse(localStorage.getItem("user") || "{}").role || "";
        const isAdminUser = currentRole === "Admin" || currentRole === "admin";
        const isManagerUser = currentRole === "Manager" || currentRole === "manager";
        if (!isAdminUser && !isManagerUser && !selectedStaff) {
            toast.error("Please select a Staff", 3000, "topRight");
            return false;
        }
        return true;
    };

    const preparePayload = () => {
        const orderItems = addData.order_items.map(({ id, ...item }) => item);
        const isShop = addData.order_by === "By Shop";
        return {
            ...addData,
            order_items: orderItems,
            payment_history: addData.payment_history,
            manager: addData.manager || "",
            manager_name: addData.manager_name || "",
            staff: addData.staff || "",
            shop_name: isShop ? addData.customer_name : "",
            shop_mobile: isShop ? addData.mobile : "",
        };
    };

    const saveOrder = async () => {
        const payload = preparePayload();
        console.log("Payload being sent:", payload);
        const response = await axios.post(`${ApiUrl}/Api/orders.php`, payload);
        if (response.status !== 200) {
            throw new Error(response.data.message || "Failed to save order data");
        }
        return response;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        setLoading(true);
        try {
            await saveOrder();
            toast.success("Order created successfully!", 3000, "topRight");
            navigate("/orders");
        } catch (error) {
            console.error("Error creating order:", error);
            toast.error(
                `Failed to create order: ${error.response?.data?.message || error.message}`,
                3000,
                "topRight"
            );
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = async () => {
        if (!validateForm()) return;

        setLoading(true);
        try {
            await saveOrder();
            toast.success("Order saved successfully!", 3000, "topRight");
            setShowModal(true);
        } catch (error) {
            console.error("Error creating order for print:", error);
            toast.error(
                `Failed to save order: ${error.response?.data?.message || error.message}`,
                3000,
                "topRight"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmPrint = () => {
        setShowModal(false);
        navigate(`/order-small-bill/${addData.order_no}`);
    };

    const handleCancelPrint = () => {
        setShowModal(false);
        navigate("/orders");
    };

    const openStaffModal = () => {
        setAddData(prev => ({
            ...prev,
            user_id: "",
            name: "",
            name_tamil: "",
            mobile: "",
            password: "",
            role: "Employee",
            manager_id: ""
        }));
        setShowStaffModal(true);
    };

    const handleStaffSubmit = async (e) => {
        e.preventDefault();
        if (!addData.user_id || !addData.name || !addData.mobile || !addData.password || !addData.role) {
            return toast.error("Please fill all required fields", 3000, "topRight");
        }
        if (addData.role === "Employee" && !addData.manager_id) {
            return toast.error("Please select a manager", 3000, "topRight");
        }

        setLoading(true);
        try {
            const payload = {
                user_id: addData.user_id.trim().toUpperCase(),
                name: addData.name,
                name_tamil: addData.name_tamil || "",
                mobile_number: addData.mobile,
                password: addData.password,
                role: addData.role,
                login_status: "Active",
                manager_id: addData.role === "Employee" ? addData.manager_id : ""
            };

            await axios.post(`${ApiUrl}/Api/user.php`, payload);
            toast.success("Staff added successfully!", 3000, "topRight");
            await fetchStaffData();

            setAddData(prev => ({
                ...prev,
                customer_id: payload.user_id,
                customer_name: payload.name,
                mobile: payload.mobile_number
            }));

            setShowStaffModal(false);
        } catch (err) {
            console.error("Failed to add staff:", err);
            toast.error("Failed to add staff. ID may already exist.", 3000, "topRight");
        } finally {
            setLoading(false);
        }
    };

    const generateCustomerId = async (customerType) => {
        if (!customerType) {
            setGenerateCustomerNumber("");
            return;
        }

        try {
            if (customerType === "Walk-In") {
                setGenerateCustomerNumber(`TJCWI-${Date.now().toString().slice(-4)}`);
            } else {
                const response = await axios.get(`${ApiUrl}/Api/customer.php/generate-customer-code`);
                setGenerateCustomerNumber(response.data?.customer_id || "");
            }
        } catch (error) {
            console.error("Error generating customer ID:", error.message);
            toast.error("Failed to generate customer ID", 3000, "topRight");
            setGenerateCustomerNumber("");
        }
    };

    const handleCustomerTypeChange = (e) => {
        const customerType = e.target.value;
        setAddData((prev) => ({
            ...prev,
            customer_type: customerType,
        }));
        generateCustomerId(customerType);
    };

    const handleAddButtonClick = () => {
        setAddData((prev) => ({
            ...prev,
            customer_type: "",
            customer_id: "",
            name: "",
            name_tamil: "",
            mobile: "",
            address: "",
            status: "Active",
        }));
        setGenerateCustomerNumber("");
        setShowCustomerModal(true);
    };

    const handleCustomerSubmit = async (e) => {
        e.preventDefault();

        if (!addData.customer_type || !addData.name || !addData.mobile || !addData.status) {
            toast.error("Please fill all required fields", 3000, "topRight");
            return;
        }

        if (!/^\d{10}$/.test(addData.mobile)) {
            toast.error("Please enter a valid 10-digit mobile number", 3000, "topRight");
            return;
        }

        setLoading(true);
        try {
            const customerPayload = {
                customer_type: addData.customer_type,
                customer_id: generateCustomerNumber,
                name: addData.name,
                name_tamil: addData.name_tamil || "",
                mobile: addData.mobile,
                address: addData.address || "",
                status: addData.status,
                created_by: "",
                created_date: getCurrentDate(),
                updated_by: "",
                updated_date: "",
            };

            const response = await axios.post(`${ApiUrl}/Api/customer.php`, customerPayload);

            if (response.status === 200) {
                toast.success("Customer added successfully!", 3000, "topRight");
                await fetchCustomerData();
                setAddData((prev) => ({
                    ...prev,
                    customer_id: generateCustomerNumber,
                    customer_name: addData.name,
                    mobile: addData.mobile,
                }));
                setShowCustomerModal(false);
            } else {
                throw new Error(response.data.message || "Failed to add customer");
            }
        } catch (error) {
            console.error("Error adding customer:", error);
            toast.error(
                `Failed to add customer: ${error.response?.data?.message || error.message}`,
                3000,
                "topRight"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleProductSubmit = async (e) => {
        e.preventDefault();

        const errors = {};
        if (!productAddData.item_name_english) errors.item_name = "Item name is required";
        if (!productAddData.category) errors.category = "Category is required";
        if (!productAddData.pure_percent) errors.pure_percent = "Purity percentage is required";
        if (!productAddData.status) errors.status = "Status is required";

        if (Object.keys(errors).length > 0) {
            setProductFormErrors(errors);
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();

            let finalTamilName = productAddData.item_name_tamil;
            if (!finalTamilName && productAddData.item_name_english) {
                finalTamilName = await translateToTamil(productAddData.item_name_english);
            }

            formData.append("item_code", productAddData.item_code || "");
            formData.append("item_name", productAddData.item_name_english || "");
            formData.append("item_name_english", productAddData.item_name_english || "");
            formData.append("item_name_tamil", finalTamilName || "");
            formData.append("category", productAddData.category || "");
            formData.append("type", productAddData.type || "");
            formData.append("pure_percent", productAddData.pure_percent || "");
            formData.append("status", productAddData.status || "");

            if (productAddData.image) {
                formData.append("image", productAddData.image);
            }

            const response = await axios.post(`${ApiUrl}/Api/product.php`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            if (response.data?.status === true || response.status === 200 || response.status === 201) {
                toast.success("Product added successfully!", 3000, "topRight");
                closeProductModal();
                await fetchProductData();
            } else {
                throw new Error(response.data?.message || "Failed to add product");
            }
        } catch (error) {
            console.error("Error adding product:", error);
            toast.error(error.response?.data?.message || "Failed to add product", 3000, "topRight");
        } finally {
            setLoading(false);
        }
    };

    const handleNotificationSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        toast.success(`${actionType} request submitted successfully!`, 3000, "topRight");
        setIsSubmitting(false);
        setShowProductModal(false);
    };

    const filteredProducts = productData.filter(
        (product) => product.category === newItem.category
    );

    useEffect(() => {
        if (!loggedInUser || userdata.length === 0) return;

        const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
        if (!currentUser) return;

        if (currentUser.role === "Manager" || currentUser.role === "manager") {
            setSelectedManager(currentUser.id.toString());
            setIsManagerLocked(true);

            const allStaff = userdata.filter(
                u => u.role === "Employee" || u.role === "employee"
            );
            setStaffList(allStaff);

            setAddData(prev => ({
                ...prev,
                manager: currentUser.user_id,
                manager_name: currentUser.name,
                staff: "",
            }));
        } else if (currentUser.role === "Employee" || currentUser.role === "employee") {
            setSelectedStaff(currentUser.name);
            setIsStaffLocked(true);

            setAddData(prev => ({
                ...prev,
                staff: currentUser.name,
            }));

            const allStaff = userdata.filter(
                u => u.role === "Employee" || u.role === "employee"
            );
            setStaffList(allStaff);
        }
    }, [loggedInUser, userdata]);

    const handleManagerChange = (e) => {
        if (isManagerLocked) return;
        const managerId = e.target.value;
        setSelectedManager(managerId);

        if (managerId) {
            const managerObj = userdata.find(u => u.id === parseInt(managerId));
            if (managerObj) {
                const allStaff = userdata.filter(
                    u => u.role === "Employee" || u.role === "employee"
                );
                setStaffList(allStaff);

                setAddData(prev => ({
                    ...prev,
                    manager: managerObj.user_id,
                    manager_name: managerObj.name,
                }));
            }
        } else {
            setStaffList([]);
            setAddData(prev => ({ ...prev, manager: "", manager_name: "" }));
        }
    };

    const handleStaffChange = (e) => {
        if (isStaffLocked) return;
        const staffName = e.target.value;
        setSelectedStaff(staffName);
        setAddData(prev => ({ ...prev, staff: staffName }));
    };

    useEffect(() => {
        toggleSidebar();
        fetchDataGenerate();
        fetchCustomerData();
        fetchProductData();
        fetchProductType();
        fetchStaffData();
        fetchUserData();
        fetchLoggedInUser();
        fetchShopList();
    }, []);

    useEffect(() => {
        setAddData((prev) => ({ ...prev, order_no: generateNumber }));
        setNewItem((prev) => ({ ...prev, order_no: generateNumber }));
    }, [generateNumber]);

    return (
        <>
            <div className="container-fluid">
                <div className="row g-3">
                    <div className="col-lg-3">
                        <div className="card p-2 h-100">
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <label className="form-label">Order ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Order No"
                                        value={generateNumber}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Order Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="order_date"
                                        value={addData.order_date}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-9">
                        <div className="card h-100 p-2">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-2">
                                    <label className="form-label">Order By</label>
                                    <select
                                        className="form-control"
                                        name="order_by"
                                        value={addData.order_by}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Order</option>
                                        <option value="By Shop">By Shop</option>
                                        <option value="By Customer">By Customer</option>
                                    </select>
                                </div>

                                <div className="col-sm-6 col-md-4">
                                    <label className="form-label">
                                        {addData.order_by === "By Shop" ? "Shop Name" : "Customer Name"}
                                    </label>
                                    {addData.order_by === "By Shop" ? (
                                        <>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter or select the shop's name"
                                                value={addData.customer_name}
                                                onChange={handleShopNameChange}
                                                list="shopNamesList"
                                                autoComplete="off"
                                            />
                                            <datalist id="shopNamesList">
                                                {shopList.map((s) => (
                                                    <option key={s.name} value={s.name} />
                                                ))}
                                            </datalist>
                                        </>
                                    ) : (
                                        <div className="input-group">
                                            <select
                                                className="form-select"
                                                onChange={handlePersonChange}
                                                value={
                                                    addData.customer_id
                                                        ? `${addData.customer_id}-${customerData.find(
                                                            (c) =>
                                                                c.customer_id === addData.customer_id &&
                                                                c.name === addData.customer_name
                                                        )?.id || ""
                                                        }`
                                                        : ""
                                                }
                                            >
                                                <option value="">Select Customer Name</option>
                                                {displayList.map((item) => (
                                                    <option
                                                        key={`${item.user_id || item.customer_id}-${item.id}`}
                                                        value={`${item.user_id || item.customer_id}-${item.id}`}
                                                    >
                                                        {item.name}{item.name_tamil ? ` / ${item.name_tamil}` : ""}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className="btn-group mx-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-dark btn-sm"
                                                    onClick={handleAddButtonClick}
                                                >
                                                    <i className="bi bi-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="col-sm-6 col-md-2">
                                    <label className="form-label">Mobile Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="mobile"
                                        placeholder="Mobile Number"
                                        value={addData.mobile}
                                        onChange={
                                            addData.order_by === "By Shop"
                                                ? handleShopMobileChange
                                                : handleInputChange
                                        }
                                        disabled={addData.order_by !== "By Shop"}
                                    />
                                </div>

                                <div className="col-sm-6 col-md-2">
                                    <label className="form-label">Delivery Status</label>
                                    <select
                                        className="form-select"
                                        name="delivery_status"
                                        value={addData.delivery_status}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Delivery</option>
                                        <option value="Inprogress">In Progress</option>
                                        <option value="Confirm">Confirm</option>
                                    </select>
                                </div>

                                {addData.delivery_status === "Confirm" && (
                                    <div className="col-sm-6 col-md-2">
                                        <label className="form-label">Delivery Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="delivery_date"
                                            value={addData.delivery_date}
                                            onChange={handleInputChange}
                                            min={addData.order_date}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    {(() => {
                        const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
                        const isAdmin = role === "Admin" || role === "admin";
                        return (
                            <>
                                <div className="col-md-3">
                                    <label className="form-label">
                                        Manager <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className="form-select"
                                        value={selectedManager}
                                        onChange={handleManagerChange}
                                        disabled={isManagerLocked}
                                    >
                                        <option value="">Select Manager</option>
                                        {userdata
                                            .filter((u) => u.role === "Manager" || u.role === "manager")
                                            .map((manager) => (
                                                <option key={manager.id} value={manager.id}>
                                                    {manager.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {!isAdmin && (
                                    <div className="col-md-3">
                                        <label className="form-label">Staff</label>
                                        <select
                                            className="form-select"
                                            value={selectedStaff}
                                            onChange={handleStaffChange}
                                            disabled={isStaffLocked}
                                        >
                                            <option value="">Select Staff</option>
                                            {staffList.map((staff) => (
                                                <option key={staff.id} value={staff.name}>
                                                    {staff.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </>
                        );
                    })()}
                </div>

                <div className="card card-body mt-2">
                    <div className="row">
                        <div className="col-md-2">
                            <label className="form-label">Select Category</label>
                            <select
                                className="form-select"
                                value={newItem.category}
                                name="category"
                                onChange={(e) => {
                                    handleItemInputChange(e);
                                    setNewItem((prev) => ({ ...prev, product: "" }));
                                }}
                            >
                                <option value="">Select Category</option>
                                <option value="Gold">Gold</option>
                                <option value="Silver">Silver</option>
                                <option value="Gold Coin">Gold Coin</option>
                                <option value="Silver Coin">Silver Coin</option>
                            </select>
                        </div>

                        <div className="col-md-2">
                            <label className="form-label">Product Name</label>
                            <div className="input-group">
                                <select
                                    className="form-select"
                                    value={newItem.product}
                                    name="product"
                                    onChange={handleItemInputChange}
                                    disabled={!newItem.category}
                                >
                                    <option value="">Select Product</option>
                                    {filteredProducts.map((product) => (
                                        <option key={product.id} value={product.item_name}>
                                            {product.item_name_english || product.item_name}
                                            {product.item_name_tamil ? ` / ${product.item_name_tamil}` : ""}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    type="button"
                                    className="btn btn-outline-dark btn-sm"
                                    onClick={openProductModal}
                                    title="Add New Product"
                                >
                                    <i className="bi bi-plus"></i>
                                </button>
                            </div>
                        </div>

                        <div className="col-md-1">
                            <label className="form-label">Qty</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                className="form-control"
                                placeholder="Qty"
                                name="quantity"
                                value={newItem.quantity}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        handleItemInputChange(e);
                                    }
                                }}
                                min="1"
                            />
                        </div>

                        <div className="col-md-1">
                            <label className="form-label">Weight (g)</label>
                            <input
                                type="text"
                                inputMode="decimal"
                                className="form-control"
                                placeholder="(g)"
                                name="weight"
                                value={newItem.weight}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d{0,3}$/.test(value)) {
                                        handleItemInputChange(e);
                                    }
                                }}
                                step="0.001"
                                min="0"
                            />
                        </div>

                        <div className="col-md-1">
                            <label className="form-label">Adjust</label>
                            <div className="input-group input-group-sm">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => handleAdjustmentChange(-1)}
                                    style={{ height: "30px" }}
                                >
                                    -
                                </button>
                                <input
                                    type="text"
                                    className="form-control form-control-sm text-center"
                                    name="adjustment"
                                    value={newItem.adjustment}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^-?\d*\.?\d*$/.test(value)) {
                                            handleItemInputChange(e);
                                        }
                                    }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => handleAdjustmentChange(1)}
                                    style={{ height: "30px" }}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        <div className="col-md-1">
                            <label className="form-label">Rate ₹</label>
                            <input
                                type="text"
                                inputMode="decimal"
                                className="form-control"
                                placeholder="Rate"
                                name="rate"
                                value={newItem.rate}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d*$/.test(value)) {
                                        handleItemInputChange(e);
                                    }
                                }}
                            />
                        </div>

                        {newItem.category !== "Gold Coin" && newItem.category !== "Silver Coin" && (
                            <>
                                <div className="col-md-1">
                                    <label className="form-label">MC</label>
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        className="form-control"
                                        placeholder="MC"
                                        name="making_charge"
                                        value={newItem.making_charge}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleItemInputChange(e);
                                            }
                                        }}
                                    />
                                </div>

                                <div className="col-md-1">
                                    <label className="form-label">MW</label>
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        className="form-control"
                                        placeholder="MW"
                                        name="making_wastage"
                                        value={newItem.making_wastage}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleItemInputChange(e);
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        )}

                        <div className="col-md-1">
                            <label className="form-label">Amount ₹</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="₹"
                                value={calculateAmount(newItem)}
                                readOnly
                                disabled
                            />
                        </div>

                        <div className="col-md-1">
                            {editingItemId === null ? (
                                <button
                                    className="btn btn-success btn-sm w-100 mt-4"
                                    onClick={handleAddItem}
                                >
                                    <i className="bi bi-plus"></i>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-info btn-sm w-100 mt-4"
                                    onClick={handleUpdateItem}
                                >
                                    <i className="bi bi-check"></i>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container-fluid mt-2">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="card card-body">
                                    <h6>Item List</h6>
                                    <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                                        <div className="table-container">
                                            <table className="table table-layout-fixed w-100">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Category</th>
                                                        <th>Product</th>
                                                        <th>Qty</th>
                                                        <th>Weight</th>
                                                        <th>Rate ₹</th>
                                                        <th>Amount ₹</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {addData.order_items.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.category}</td>
                                                            <td>
                                                                {item.item_name_tamil
                                                                    ? `${item.item_name_english || item.product} / ${item.item_name_tamil}`
                                                                    : item.product}
                                                            </td>
                                                            <td>{item.quantity}</td>
                                                            <td>{item.weight}</td>
                                                            <td>{item.rate}</td>
                                                            <td>₹{item.amount}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-warning me-1"
                                                                    onClick={() => handleEditItem(item)}
                                                                >
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleRemoveItem(item.id)}
                                                                >
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {addData.order_items.length === 0 && (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">
                                                                No items added
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                            <div className="row">
                                                <div className="col-lg-8"></div>
                                                <div className="col-lg-4">
                                                    <div className="d-flex">
                                                        <h6 className="mt-2">Total: </h6>
                                                        <input
                                                            className="form-control mx-2"
                                                            placeholder="₹"
                                                            readOnly
                                                            value={addData.total || "0.00"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 mb-5">
                            <div className="card p-3">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="form-label">Advance</label>
                                    </div>
                                    <div className="col-md-5">
                                        <select
                                            className="form-select"
                                            value={addData.advance_paytype}
                                            onChange={(e) => {
    const selectedValue = e.target.value;
    setAddData((prev) => ({ ...prev, advance_paytype: selectedValue }));
    if (parseFloat(addData.advance_amount) > 0) {   // was: if (addData.advance_amount)
        handleAdvanceChange({
            target: { name: "advance_amount", value: addData.advance_amount },
        });
    }
}}
                                        >
                                            <option value="">Select Paytype</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Gpay">Gpay</option>
                                            <option value="Phonepe">Phonepe</option>
                                            <option value="Paytm">Paytm</option>
                                            <option value="Credit">Credit</option>
                                            <option value="Debit">Debit</option>
                                        </select>
                                    </div>
                                    <div className="col-md-5">
                                        <input
                                            type="tel"
                                            className="form-control"
                                            name="advance_amount"
                                            value={addData.advance_amount}
                                            onChange={(e) =>
                                                handleAdvanceChange({
                                                    target: {
                                                        name: e.target.name,
                                                        value: e.target.value.replace(/\D/g, ""),
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">Total</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="tel"
                                            className="form-control"
                                            value={addData.total || ""}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="row mb-2 d-flex justify-content-center">
                                    <button
                                        className="btn btn-success btn-sm w-50"
                                        onClick={() => setPaymentModal(true)}
                                    >
                                        Add Payment +
                                    </button>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">Paid</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="paid"
                                            value={addData.paid || ""}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">Balance</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={addData.balance || ""}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4">
                                        <button
                                            className="btn btn-sm btn-secondary w-100"
                                            onClick={() => navigate("/orders")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-lg-4">
                                        <button
                                            className="btn btn-sm btn-primary w-100"
                                            onClick={handlePrint}
                                            disabled={loading}
                                        >
                                            Print
                                        </button>
                                    </div>
                                    <div className="col-lg-4">
                                        <button
                                            className="btn btn-sm btn-success w-100"
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Payment Modal */}
            {paymentModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title text-primary">Add Payment</h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setPaymentModal(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <p>Advance: <span className="text-primary">{addData.advance_amount || "0.00"}</span></p>
                                    </div>
                                    <div className="col-lg-4">
                                        <p>Balance: <span className="text-success">{addData.balance || "0.00"}</span></p>
                                    </div>
                                    <div className="col-lg-4">
                                        <p>Paid: <span className="text-primary">{addData.paid || "0.00"}</span></p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <select
                                            className="form-select"
                                            value={paymentType}
                                            onChange={(e) => setPaymentType(e.target.value)}
                                        >
                                            <option value="">Select Paytype</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Gpay">Gpay</option>
                                            <option value="Phonepe">Phonepe</option>
                                            <option value="Paytm">Paytm</option>
                                            <option value="Credit">Credit</option>
                                            <option value="Debit">Debit</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-4">
                                        <input
                                            type="tel"
                                            className="form-control"
                                            value={paymentAmount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                            placeholder="Enter Amount"
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>
                                    <div className="col-lg-2">
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={handleAddPayment}
                                        >
                                            Add +
                                        </button>
                                    </div>
                                </div>

                                <div className="card mt-3" style={{ borderRadius: "5px", backgroundColor: "#E8F0FA" }}>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-border">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Pay Type</th>
                                                        <th>Paid Amount</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {payments.length > 0 ? (
                                                        payments.map((payment, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{payment.payment_type}</td>
                                                                <td>₹{payment.amount}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-light btn-sm me-2"
                                                                        onClick={() => handleEditPayment(index)}
                                                                    >
                                                                        <i className="fa fa-edit text-info"></i>
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-light btn-sm me-2"
                                                                        onClick={() => handleDeletePayment(index)}
                                                                    >
                                                                        <i className="fa fa-trash text-danger"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">No payments added</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-end mt-2">
                                    <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => setPaymentModal(false)}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Print Modal */}
            {showModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title text-primary">Print Confirmation</h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ fontSize: "10px" }}
                                    onClick={handleCancelPrint}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="text-center">
                                    <p>Do you want to print the order bill?</p>
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm mx-2"
                                        onClick={handleCancelPrint}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={handleConfirmPrint}
                                        disabled={loading}
                                    >
                                        {loading ? "Processing..." : "Yes"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Customer Modal */}
            {showCustomerModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title text-primary">Add Customer</h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setShowCustomerModal(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleCustomerSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="customerType" className="form-label">
                                                    Customer Type <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="customerType"
                                                    value={addData.customer_type}
                                                    onChange={handleCustomerTypeChange}
                                                    required
                                                >
                                                    <option value="" disabled>Select Customer Type</option>
                                                    <option value="Walk-In">Walk-In</option>
                                                    <option value="Regular">Regular</option>
                                                    <option value="Retailer">Retailer</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="customerId" className="form-label">
                                                    Customer ID
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="customerId"
                                                    placeholder="Customer ID will be generated"
                                                    value={generateCustomerNumber}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="name" className="form-label">
                                                    Name <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="name"
                                                        placeholder="Enter Name (Tamil auto-translates)"
                                                        value={addData.name}
                                                        onChange={(e) =>
                                                            setAddData({ ...addData, name: e.target.value, name_tamil: "" })
                                                        }
                                                        onBlur={async (e) => {
                                                            const val = e.target.value.trim();
                                                            if (val && !addData.name_tamil) {
                                                                const tamil = await translateToTamil(val);
                                                                if (tamil) setAddData(prev => ({ ...prev, name_tamil: tamil }));
                                                            }
                                                        }}
                                                        required
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        disabled={isTranslating || !addData.name}
                                                        onClick={async () => {
                                                            const tamil = await translateToTamil(addData.name);
                                                            if (tamil) setAddData(prev => ({ ...prev, name_tamil: tamil }));
                                                        }}
                                                    >
                                                        {isTranslating ? <span className="spinner-border spinner-border-sm" /> : "🌐 தமிழ்"}
                                                    </button>
                                                </div>
                                                {addData.name_tamil && (
                                                    <small className="text-muted mt-1 d-block">
                                                        <strong>Tamil:</strong> {addData.name_tamil}
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm p-0 ms-2 text-muted"
                                                            onClick={() => setAddData(prev => ({ ...prev, name_tamil: "" }))}
                                                        >
                                                            ✕ clear
                                                        </button>
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="mobile" className="form-label">
                                                    Mobile Number <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="mobile"
                                                    placeholder="Enter Mobile"
                                                    value={addData.mobile}
                                                    onChange={(e) =>
                                                        setAddData({ ...addData, mobile: e.target.value })
                                                    }
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="address"
                                            placeholder="Enter Address"
                                            value={addData.address}
                                            onChange={(e) =>
                                                setAddData({ ...addData, address: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="customerStatus" className="form-label">
                                            Status <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="status"
                                            value={addData.status}
                                            onChange={(e) =>
                                                setAddData({ ...addData, status: e.target.value })
                                            }
                                            required
                                        >
                                            <option value="" disabled>Select Status</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>

                                    <div className="text-center mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm px-4"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Staff Modal */}
            {showStaffModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="text-primary">Add Staff</h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowStaffModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleStaffSubmit}>

                                    {/* Row 1: Staff ID + Status */}
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="form-label">
                                                Staff ID <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e.g. EMP001"
                                                value={addData.user_id || ""}
                                                onChange={(e) =>
                                                    setAddData((prev) => ({
                                                        ...prev,
                                                        user_id: e.target.value.toUpperCase(),
                                                    }))
                                                }
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label">Status</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value="Active"
                                                disabled
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    {/* Row 2: Name + Mobile */}
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="form-label">
                                                Name <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name (Tamil auto-translates)"
                                                    value={addData.name}
                                                    onChange={(e) =>
                                                        setAddData((prev) => ({
                                                            ...prev,
                                                            name: e.target.value,
                                                            name_tamil: "",
                                                        }))
                                                    }
                                                    onBlur={async (e) => {
                                                        const val = e.target.value.trim();
                                                        if (val && !addData.name_tamil) {
                                                            const tamil = await translateToTamil(val);
                                                            if (tamil) setAddData(prev => ({ ...prev, name_tamil: tamil }));
                                                        }
                                                    }}
                                                    required
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    disabled={isTranslating || !addData.name}
                                                    onClick={async () => {
                                                        const tamil = await translateToTamil(addData.name);
                                                        if (tamil) setAddData(prev => ({ ...prev, name_tamil: tamil }));
                                                    }}
                                                >
                                                    {isTranslating
                                                        ? <span className="spinner-border spinner-border-sm" />
                                                        : "🌐 தமிழ்"}
                                                </button>
                                            </div>
                                            {addData.name_tamil && (
                                                <small className="text-muted mt-1 d-block">
                                                    <strong>Tamil:</strong> {addData.name_tamil}
                                                    <button
                                                        type="button"
                                                        className="btn btn-link btn-sm p-0 ms-2 text-muted"
                                                        onClick={() => setAddData(prev => ({ ...prev, name_tamil: "" }))}
                                                    >
                                                        ✕ clear
                                                    </button>
                                                </small>
                                            )}
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label">
                                                Mobile <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                maxLength="10"
                                                placeholder="Enter Mobile Number"
                                                value={addData.mobile}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                    setAddData((prev) => ({ ...prev, mobile: val }));
                                                }}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Row 3: Role + Password */}
                                    <div className="row mt-2">
                                        <div className="col-6">
                                            <label className="form-label">
                                                Role <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={addData.role}
                                                onChange={(e) =>
                                                    setAddData((prev) => ({
                                                        ...prev,
                                                        role: e.target.value,
                                                    }))
                                                }
                                                required
                                            >
                                                <option value="Employee">Employee</option>
                                                <option value="Manager">Manager</option>
                                            </select>
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label">
                                                Password <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={addData.password}
                                                onChange={(e) =>
                                                    setAddData((prev) => ({
                                                        ...prev,
                                                        password: e.target.value,
                                                    }))
                                                }
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Conditional Manager dropdown for Employee role */}
                                    {addData.role === "Employee" && (
                                        <div className="mt-2">
                                            <label className="form-label">
                                                Manager <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={addData.manager_id}
                                                onChange={(e) =>
                                                    setAddData((prev) => ({
                                                        ...prev,
                                                        manager_id: e.target.value,
                                                    }))
                                                }
                                                required
                                            >
                                                <option value="">Select Manager</option>
                                                {staffData
                                                    .filter(
                                                        (s) =>
                                                            s.role === "Manager" &&
                                                            s.login_status === "Active"
                                                    )
                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                    .map((manager) => (
                                                        <option key={manager.user_id} value={manager.user_id}>
                                                            {manager.user_id} - {manager.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    )}

                                    <div className="text-center mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm"
                                            disabled={loading}
                                        >
                                            {loading ? "Saving..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Product Modal */}
            {showProductModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                    aria-labelledby="addProductModalLabel"
                    aria-hidden={!showProductModal}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title text-primary" id="addProductModalLabel">
                                    Add Product
                                </h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ fontSize: "10px" }}
                                    onClick={closeProductModal}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleProductSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="item_code" className="form-label">
                                                    Item Code
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="item_code"
                                                    value={productAddData.item_code}
                                                    disabled
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="product_category" className="form-label">
                                                    Category <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className={`form-select ${productFormErrors.category ? "is-invalid" : ""}`}
                                                    id="product_category"
                                                    value={productAddData.category}
                                                    onChange={(e) =>
                                                        setProductAddData({
                                                            ...productAddData,
                                                            category: e.target.value,
                                                        })
                                                    }
                                                >
                                                    <option value="">Select Category</option>
                                                    <option value="Gold">Gold</option>
                                                    <option value="Silver">Silver</option>
                                                    <option value="Gold Coin">Gold Coin</option>
                                                    <option value="Silver Coin">Silver Coin</option>
                                                </select>
                                                {productFormErrors.category && (
                                                    <div className="invalid-feedback">{productFormErrors.category}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <label htmlFor="item_name_english" className="form-label">
                                                    Item Name <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${productFormErrors.item_name ? "is-invalid" : ""}`}
                                                        id="item_name_english"
                                                        placeholder="Enter item name in English (Tamil will auto-translate)"
                                                        value={productAddData.item_name_english}
                                                        onChange={(e) =>
                                                            setProductAddData({
                                                                ...productAddData,
                                                                item_name_english: e.target.value,
                                                                item_name: e.target.value,
                                                                item_name_tamil: "",
                                                            })
                                                        }
                                                        onBlur={async (e) => {
                                                            const val = e.target.value.trim();
                                                            if (val && !productAddData.item_name_tamil) {
                                                                const tamil = await translateToTamil(val);
                                                                if (tamil) {
                                                                    setProductAddData((prev) => ({
                                                                        ...prev,
                                                                        item_name_tamil: tamil,
                                                                    }));
                                                                    toast.info(`Tamil translation: ${tamil}`, 2000, "topRight");
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        title="Translate to Tamil"
                                                        style={{ height: "35px" }}
                                                        disabled={isTranslating || !productAddData.item_name_english}
                                                        onClick={async () => {
                                                            const tamil = await translateToTamil(productAddData.item_name_english);
                                                            if (tamil) {
                                                                setProductAddData((prev) => ({
                                                                    ...prev,
                                                                    item_name_tamil: tamil,
                                                                }));
                                                                toast.success("Translated successfully!", 1500, "topRight");
                                                            } else {
                                                                toast.error("Translation failed. Please try again.", 2000, "topRight");
                                                            }
                                                        }}
                                                    >
                                                        {isTranslating ? (
                                                            <span className="spinner-border spinner-border-sm" />
                                                        ) : (
                                                            "🌐 Translate"
                                                        )}
                                                    </button>
                                                </div>
                                                {productAddData.item_name_tamil && (
                                                    <small className="text-muted mt-1 d-block">
                                                        <strong>Tamil:</strong> {productAddData.item_name_tamil}
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm p-0 ms-2 text-muted"
                                                            onClick={() =>
                                                                setProductAddData((prev) => ({
                                                                    ...prev,
                                                                    item_name_tamil: "",
                                                                }))
                                                            }
                                                        >
                                                            ✕ clear
                                                        </button>
                                                    </small>
                                                )}
                                                {productFormErrors.item_name && (
                                                    <div className="invalid-feedback">{productFormErrors.item_name}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="pure_percent" className="form-label">
                                                    Purity (%) <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.1"
                                                    min="0"
                                                    max="100"
                                                    className={`form-control ${productFormErrors.pure_percent ? "is-invalid" : ""}`}
                                                    id="pure_percent"
                                                    placeholder="e.g. 99.9"
                                                    value={productAddData.pure_percent}
                                                    onChange={(e) =>
                                                        setProductAddData({
                                                            ...productAddData,
                                                            pure_percent: e.target.value,
                                                        })
                                                    }
                                                />
                                                {productFormErrors.pure_percent && (
                                                    <div className="invalid-feedback">{productFormErrors.pure_percent}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label htmlFor="product_status" className="form-label">
                                                    Status <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className={`form-select ${productFormErrors.status ? "is-invalid" : ""}`}
                                                    id="product_status"
                                                    value={productAddData.status}
                                                    onChange={(e) =>
                                                        setProductAddData({
                                                            ...productAddData,
                                                            status: e.target.value,
                                                        })
                                                    }
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option>
                                                </select>
                                                {productFormErrors.status && (
                                                    <div className="invalid-feedback">{productFormErrors.status}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="mb-3">
                                            <label htmlFor="product_image" className="form-label">
                                                Image Upload
                                            </label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="product_image"
                                                onChange={(e) =>
                                                    setProductAddData({
                                                        ...productAddData,
                                                        image: e.target.files[0],
                                                    })
                                                }
                                                accept="image/*"
                                            />
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm px-4"
                                            disabled={loading}
                                        >
                                            {loading ? "Adding..." : "Add Product"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Backdrop */}
            {(paymentModal || showModal || showCustomerModal || showProductModal || showStaffModal) && (
                <div className="modal-backdrop fade show"></div>
            )}
        </>
    );
}

export default AddOrder;